import { useInfiniteQuery } from "@tanstack/react-query";

import { SEARCH_PAGE_SIZE, searchWords } from "@/api/words";
import type { SearchWordItem } from "@/types/common";

/** 단어 검색 — 300ms 디바운스된 query를 받아 무한 스크롤 */
export function useSearchWordsQuery(debouncedQuery: string) {
  const trimmed = debouncedQuery.trim();

  return useInfiniteQuery({
    queryKey: ["searchWords", trimmed],
    queryFn: ({ pageParam }) => searchWords(trimmed, pageParam),
    initialPageParam: 0,
    getNextPageParam: (lastPage, _allPages, lastPageParam) =>
      lastPage.length < SEARCH_PAGE_SIZE ? undefined : lastPageParam + SEARCH_PAGE_SIZE,
    enabled: trimmed.length >= 1,
    staleTime: 1000 * 60 * 5,
    select: data => ({
      ...data,
      items: data.pages.flatMap(page =>
        page.map(
          (row): SearchWordItem => ({
            id: row.id,
            word: row.word,
            meaning: row.meaning,
            setId: row.word_sets?.id ?? row.set_id,
            setTitle: row.word_sets?.title ?? "",
            isFree: row.word_sets?.is_free ?? true,
          }),
        ),
      ),
    }),
  });
}
